<template>
  <!-- 抄表审核 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <!-- 第一行 -->
        <a-row :gutter="12" style="margin-bottom: 12px">
          <a-col :md="5" :sm="12">
            <a-form-item label="用户">
              <UserSelect v-model="query.userCode" @change="onUserSelectChange" />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="抄表员">
              <a-select placeholder="请选择" v-model="query.readerId" allow-clear style="width: 100%">
                <a-select-option v-for="item in meterReaderList" :key="item.id" :value="item.id">
                  {{ item.readerName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="表册分组">
              <a-select placeholder="请选择" v-model="query.groupId" allow-clear @change="onQueryGroupChange"
                style="width: 100%">
                <a-select-option v-for="item in bookGroupList" :key="item.id" :value="item.id">
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="表册">
              <a-select placeholder="请选择" v-model="query.bookId" allow-clear show-search
                :filter-option="filterMeterBookOption" :disabled="!query.groupId" style="width: 100%">
                <a-select-option v-if="!query.groupId" disabled value=""> 请先选择表册分组 </a-select-option>
                <a-select-option v-for="item in meterBooksList" :key="item.id" :value="item.id">
                  {{ item.bookName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <!-- 第二行 -->
        <a-row :gutter="12">
          <a-col :md="3" :sm="12">
            <a-form-item label="状态">
              <a-select placeholder="请选择" v-model="query.dataStatus" allow-clear style="width: 100%">
                <a-select-option :value="1">待审核</a-select-option>
                <a-select-option :value="2">已审核</a-select-option>
                <!-- <a-select-option :value="3">已推送</a-select-option> -->
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="3" :sm="12">
            <a-form-item label="水表状况">
              <a-select placeholder="请选择" v-model="query.meterStatus" allow-clear style="width: 100%">
                <a-select-option value>请选择</a-select-option>
                <a-select-option :value="1">正常</a-select-option>
                <a-select-option :value="2">异常</a-select-option>
                <a-select-option :value="3">已取表</a-select-option>
                <a-select-option :value="4">关闸</a-select-option>
                <a-select-option :value="5">重转</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="环比增长率">
              <div style="display: flex; align-items: center; gap: 8px; width: 100%">
                <a-input v-model="query.minGrowthRate" placeholder="最小值" allow-clear />
                <span style="color: #999">~</span>
                <a-input v-model="query.maxGrowthRate" placeholder="最大值" allow-clear />
              </div>
            </a-form-item>
          </a-col>

          <a-col :md="12" :sm="24">
            <a-form-item>
              <a-button type="primary" @click="searchList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <span>
                <a-button class="push-btn" @click="dataPush()" v-action:edit
                  :disabled="pagination.total === 0">数据推送</a-button>
              </span>

              <a-button class="push-btn" @click="autoDatePush()" v-action:edit>自动推送设置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="exportHandleIdList()" v-action:export
                :loading="exportLoading">导出</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="quickReview()" v-action:edit>快速审核</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table size="middle" rowKey="id" bordered
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange" :scroll="{ x: 2200 }">
      <template slot="dataStatus" slot-scope="text">
        <span :class="getStatusColor(text)">{{
          text == '1' ? '待审核' : text == '2' ? '已审核' : text == '3' ? '已推送' : ''
        }}</span>
      </template>
      <template slot="meterStatus" slot-scope="text">
        <span :class="getMeterStatusColor(text)">{{ getMeterStatusText(text) }}</span>
      </template>
      <span slot="action" slot-scope="text, record">
        <a @click="handleViewImage(record)" style="margin-right: 15px">查看图片</a>
        <a @click="handleReview(record)" v-action:edit> 复核 </a>
      </span>
    </a-table>

    <!-- 数据推送 -->
    <a-modal :title="`数据推送 - ${pushScope === 1 ? '全部推送' : '勾选推送'}`" class="datepush" :width="600" :visible="visiblepush"
      @ok="handlePushOk" @cancel="handlePushCancel" :confirmLoading="pushLoading"
      :okButtonProps="{ disabled: pushScope === 2 && selectedRows.length === 0 }" :centered="true">
      <div class="promptone">
        <span><a-icon type="info-circle" theme="twoTone" twoToneColor="#ed7b2f" />
          数据将直接推送至营收系统，进行此操作时请确保数据无误！</span>
      </div>
      <div class="select-area">
        <span>推送范围选择：</span>
        <a-radio-group v-model="pushScope" @change="onPushScopeChange">
          <a-radio :value="1">全部推送</a-radio>
          <a-radio :value="2">勾选推送</a-radio>
        </a-radio-group>
      </div>

      <!-- 推送进度提示 -->
      <div v-if="pushLoading" class="push-progress">
        <a-spin size="large" />
        <div class="progress-text">
          <div class="progress-title">正在推送数据...</div>
          <div class="progress-desc">请耐心等待，不要关闭此窗口</div>
        </div>
      </div>

      <span class="tip">注：选择"全部推送"则推送当前条件下筛选出来的全部数据。</span>
    </a-modal>

    <!-- 自动推送设置 -->
    <a-modal title="自动推送设置" class="datepush" :width="650" :visible="visibleatuo" @ok="handlePushOk"
      @cancel="handlePushCancel" :confirmLoading="autoPushLoading" :centered="true">
      <a-spin :spinning="loadingCurrentSettings" tip="正在加载当前设置...">
        <div style="display: flex; flex-direction: column; justify-content: center; min-height: 300px;">
          <div class="prompttwo">
            <span><a-icon type="info-circle" theme="twoTone" twoToneColor="#0052d9" />
              开启推送后，根据设定的时间和周期自动推送状态为"已审核"的数据至营收系统。</span>
          </div>
          <a-form :model="autoPushForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
            <a-form-item label="是否开启" style="display: flex; align-items: center;">
              <a-switch checked-children="开" un-checked-children="关" v-model="autoPushEnabled" />
            </a-form-item>
            <a-form-item label="推送时间" :required="autoPushEnabled"
              :validate-status="autoPushEnabled && !pushTime ? 'error' : ''"
              :help="autoPushEnabled && !pushTime ? '请选择推送时间' : ''">
              <a-date-picker show-time format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss"
                style="width: 100%" v-model="pushTime" :disabled="!autoPushEnabled" placeholder="请选择推送时间" />
            </a-form-item>
            <a-form-item label="推送周期" :required="autoPushEnabled"
              :validate-status="autoPushEnabled && (pushCycle === null || pushCycle === '') ? 'error' : ''"
              :help="autoPushEnabled && (pushCycle === null || pushCycle === '') ? '请选择推送周期' : ''">
              <a-select placeholder="请选择推送周期" style="width: 100%" allow-clear v-model="pushCycle"
                :disabled="!autoPushEnabled">
                <a-select-option :value="0">本次</a-select-option>
                <a-select-option :value="1">每月</a-select-option>
              </a-select>
            </a-form-item>
          </a-form>
        </div>
      </a-spin>
    </a-modal>

    <!-- 快速审核 -->
    <a-modal title="快速审核" :visible="visiblereview && !!currentReview" :footer="null" :width="900"
      @cancel="closeQuickReviewModal">
      <div v-if="!currentReview" style="text-align: center; padding: 40px">
        <a-spin size="large" />
        <div style="margin-top: 16px">加载审核数据中...</div>
      </div>

      <a-row v-else :gutter="24">
        <!-- 左侧用户信息 -->
        <a-col :span="12">
          <div class="user-info-card">
            <div class="info-grid">
              <div class="info-label">用户编码：</div>
              <div class="info-value">{{ currentReview.userCode || '-' }}</div>
              <div class="info-label">用户名称：</div>
              <div class="info-value">{{ currentReview.userName || '-' }}</div>
              <div class="info-label">用户地址：</div>
              <div class="info-value">{{ currentReview.userAddress || '-' }}</div>
              <div class="info-label">水表编号：</div>
              <div class="info-value">{{ currentReview.waterAreaCode || '-' }}</div>
              <div class="info-label">表册分组：</div>
              <div class="info-value">{{ currentReview.groupName || '-' }}</div>
              <div class="info-label">所属表册：</div>
              <div class="info-value">{{ currentReview.bookName || '-' }}</div>
              <div class="info-label">上期行至：</div>
              <div class="info-value">{{ currentReview.previousReading || '-' }}</div>
              <div class="info-label">上期用水量：</div>
              <div class="info-value">{{ currentReview.previousUsage || '-' }}</div>
            </div>
            <div class="water-data-grid">
              <div class="data-label">本期行至：</div>
              <div class="data-value water-value">{{ currentReview.currentReading || '-' }}</div>
              <div class="data-label">本期用水量：</div>
              <div class="data-value water-value">{{ currentReview.currentUsage || '-' }}</div>
              <div class="data-label">补充水量：</div>
              <div class="data-value water-value">{{ currentReview.supplementaryWater || '-' }}</div>
              <div class="data-label">环比增长率：</div>
              <div class="data-value water-value">{{ currentReview.growthRate || '-' }}</div>
            </div>
            <div class="meter-status-grid">
              <div class="info-label">水表状况：</div>
              <div class="info-value" :class="getMeterStatusColor(currentReview.meterStatus)">
                {{ getMeterStatusText(currentReview.meterStatus) }}
              </div>
              <div class="info-label">备注：</div>
              <div class="info-value">{{ currentReview.auditComment || '-' }}</div>
              <div class="info-label">抄表员：</div>
              <div class="info-value">{{ currentReview.readerName || '-' }}</div>
              <div class="info-label">抄表时间：</div>
              <div class="info-value">{{ currentReview.readingTime || '-' }}</div>
              <div class="info-label">状态：</div>
              <div class="info-value" :class="getStatusColor(currentReview.dataStatus)">
                {{
                  currentReview.dataStatusText ||
                  (currentReview.dataStatus === 1 ? '待审核' : currentReview.dataStatus === 2 ? '已审核' : '-')
                }}
              </div>
            </div>
          </div>
        </a-col>
        <!-- 右侧图片 -->
        <a-col :span="12">
          <div class="meter-image-card">
            <h3 class="section-title">水表图片</h3>
            <div class="meter-image-container">
              <div v-if="currentReview.imageUrl" class="image-magnifier-container" @mousemove="handleMouseMove"
                @mouseleave="handleMouseLeave" @click="previewImage(currentReview.imageUrl)">
                <img ref="magnifierImage" :src="currentReview.imageUrl" alt="水表照片" class="water-meter-image" />
                <div class="magnifier-lens" :style="magnifierLensStyle" v-show="showMagnifier"></div>
                <div class="magnifier-result" :style="magnifierResultStyle" v-show="showMagnifier"></div>
              </div>
              <div v-else class="image-placeholder">
                <a-empty description="暂无图片" />
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
      <!-- 统计信息 -->
      <div class="review-stats-bar" style="margin-top: 12px; color: #666; font-size: 15px; text-align: right">
        共 <span style="color: #1890ff">{{ reviewStats.total || 0 }}</span> 条数据， 审核通过
        <span style="color: #52c41a">{{ reviewStats.approved || 0 }}</span> 条， 待审核
        <span style="color: #1890ff">{{ reviewStats.pending || 0 }}</span> 条
      </div>
      <div class="review-footer">
        <button class="recheck-button" @click="handleReview(currentReview)" v-action:edit>复核</button>
        <div class="action-buttons">
          <button class="skip-button" @click="handleSkip" v-action:edit>跳过</button>
          <button class="approve-button" @click="handleApprove" v-action:edit>审核通过</button>
        </div>
      </div>
    </a-modal>

    <!-- 复核 -->
    <a-modal title="复核" :width="600" :visible="visibles" @ok="handleSubmit" @cancel="handleCancelh"
      wrapClassName="review-modal-zindex" :zIndex="2002" :bodyStyle="{ maxHeight: '65vh', overflowY: 'auto' }">
      <a-form-model class="log-form" :model="reviewForm" ref="ruleForm" :rules="reviewRules" :label-col="{ span: 5 }"
        :wrapper-col="{ span: 16 }">
        <a-form-model-item label="用户" prop="userName">
          <a-input v-model="reviewForm.userName" disabled />
        </a-form-model-item>
        <a-form-model-item label="用户地址" prop="userAddress">
          <a-input v-model="reviewForm.userAddress" disabled />
        </a-form-model-item>
        <a-form-model-item label="所属表册">
          <a-input v-model="reviewForm.bookName" disabled />
        </a-form-model-item>
        <a-form-model-item label="上期行至" prop="previousReading">
          <a-input v-model="reviewForm.previousReading" disabled /></a-form-model-item>
        <a-form-model-item label="水表状况">
          <a-select v-model="reviewForm.meterStatus" disabled style="width: 100%">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">异常</a-select-option>
            <a-select-option :value="3">已取表</a-select-option>
            <a-select-option :value="4">关闸</a-select-option>
            <a-select-option :value="5">重转</a-select-option>
          </a-select>
        </a-form-model-item>
      
        <a-form-model-item label="复核方式" prop="reviewType">
          <a-select v-model="reviewForm.reviewType" @change="onReviewTypeChange" @click="handleSelectClick"
            placeholder="请选择复核方式" style="width: 100%" allowClear>
            <a-select-option value="1">管理员复核</a-select-option>
            <a-select-option value="2">抄表员复核</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="旧表读数" v-if="reviewForm.meterStatus === 5">
          <a-input v-model="reviewForm.oldMeterReading" type="number" placeholder="请输入旧表读数" :min="0" :step="0.01" />
        </a-form-model-item>
        <!-- 抄表员复核 -->
        <template v-if="reviewForm.reviewType === '2'">
          <a-form-model-item label="抄表员" prop="readerName" required>
            <a-select v-model="reviewForm.readerName" placeholder="请选择抄表员" style="width: 100%" allowClear>
              <a-select-option v-for="reader in meterReaderList" :key="reader.id" :value="reader.readerName">
                {{ reader.readerName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="抄表开始日期" prop="startDate" required>
            <a-date-picker v-model="reviewForm.startDate" style="width: 100%" format="YYYY-MM-DD"
              value-format="YYYY-MM-DD" placeholder="请选择开始日期" :disabled-date="disabledDate" />
          </a-form-model-item>
          <a-form-model-item label="抄表结束日期" prop="endDate" required>
            <a-date-picker v-model="reviewForm.endDate" style="width: 100%" format="YYYY-MM-DD"
              value-format="YYYY-MM-DD" placeholder="请选择结束日期" :disabled-date="disabledDate" />
          </a-form-model-item>
          <a-form-model-item label="备注" prop="comment">
            <a-textarea v-model="reviewForm.comment" :rows="3" placeholder="请输入备注信息（可选）" />
          </a-form-model-item>
        </template>
        <!-- 管理员复核 -->
        <template v-else-if="reviewForm.reviewType === '1'">
          <a-form-model-item label="本期行至" prop="currentReading" required>
            <a-input v-model="reviewForm.currentReading" type="number" placeholder="请输入大于0的数字" :min="0.01"
              :step="0.01" />
          </a-form-model-item>
          <a-form-model-item label="本期用水量" prop="currentUsage">
            <a-input v-model="reviewForm.currentUsage" type="number" placeholder="请输入非负数（可选）" :min="0"
              :step="0.01" />
          </a-form-model-item>
          <a-form-model-item label="补充水量" prop="supplementaryWater">
            <a-input v-model="reviewForm.supplementaryWater" type="number" placeholder="请输入非负数（可选）" :min="0"
              :step="0.01" />
          </a-form-model-item>
          <a-form-model-item label="备注" prop="comment">
            <a-textarea v-model="reviewForm.comment" :rows="3" placeholder="请输入备注信息（可选）" />
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-modal>

    <!-- 图片预览模态框 -->
    <a-modal title="水表图片预览" width="60%" :footer="null" :visible="imagePreviewVisible" @cancel="handleImagePreviewCancel"
      :bodyStyle="{ padding: '0', textAlign: 'center' }">
      <div class="image-preview-container">
        <img v-if="previewImageUrl" :src="previewImageUrl" alt="水表图片预览" class="preview-image" />
      </div>
    </a-modal>

    <!-- 推送成功提示弹窗 -->
    <a-modal title="提示" :visible="pushSuccessVisible" @ok="closePushSuccessModal" :width="500" :closable="true"
      :maskClosable="false" :cancelButtonProps="{ style: { display: 'none' } }" okText="确定" okType="primary"
      class="push-success-modal">
      <div style="text-align: center">
        <!-- 提示信息 -->
        <p style="font-size: 16px; color: #333; margin: 0; line-height: 1.6">
          {{ pushSuccessMessage }} 
        </p>

      </div>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import axios from 'axios'
import UserSelect from '@/views/meter-reading/components/UserSelect.vue'
const columns = [
  { title: '用户编码', dataIndex: 'userCode', key: 'userCode', width: 120 },
  { title: '用户名称', dataIndex: 'userName', key: 'userName', width: 120 },
  { title: '水表编号', dataIndex: 'waterAreaCode', key: 'waterAreaCode', width: 120 },
  { title: '用户地址', dataIndex: 'userAddress', ellipsis: true, width: 200, key: 'userAddress' },
  { title: '表册分组', dataIndex: 'groupName', key: 'groupName', width: 100 },
  { title: '所属表册', dataIndex: 'bookName', key: 'bookName', width: 120 },
  { title: '抄表员', dataIndex: 'readerName', key: 'readerName', width: 100 },
  {
    title: '状态',
    dataIndex: 'dataStatus',
    scopedSlots: { customRender: 'dataStatus' },
    key: 'dataStatus',
    width: 100,
  },

  { title: '上期行至', dataIndex: 'previousReading', key: 'previousReading', width: 100 },
  { title: '上期用水量（m³）', dataIndex: 'previousUsage', key: 'previousUsage', width: 120 },
  { title: '本期行至', dataIndex: 'currentReading', key: 'currentReading', width: 100 },
  { title: '本期用水量（m³）', dataIndex: 'currentUsage', key: 'currentUsage', width: 120 },
  { title: '补充水量', dataIndex: 'supplementaryWater', key: 'supplementaryWater', width: 100 },
  { title: '环比增长率（%）', dataIndex: 'growthRate', key: 'growthRate', width: 120 },
  {
    title: '水表状况',
    dataIndex: 'meterStatus',
    key: 'meterStatus',
    width: 100,
    scopedSlots: { customRender: 'meterStatus' },
  },
  { title: '旧表读数', dataIndex: 'oldMeterReading', key: 'oldMeterReading', width: 100 },

  { title: '抄表时间', dataIndex: 'readingTime', width: 150, key: 'readingTime' },
  { title: '备注', dataIndex: 'auditComment', key: 'auditComment', width: 150, ellipsis: true },
  {
    title: '操作',
    width: 180,
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    key: 'action',
    fixed: 'right',
  },
]

export default {
  components: {
    UserSelect,
  },
  mixins: [mixinViewModule],
  name: 'Task',
  data () {
    return {
      exportDataUrl: 'meter-manager/water_meter_audit/export',
      currentReview: {},

      visiblepush: false,
      visibleatuo: false,
      visiblereview: false,
      visibles: false,
      pushSuccessVisible: false,
      pushSuccessMessage: '',

      queryUrl: '/meter-manager/water_meter_audit/page',
      query: {
        userName: '',
        userCode: '',
        tenantId: this.$store.state.user.info.tenantId,
        readerId: '',
        groupId: '',
        bookId: '',
        dataStatus: '',
        meterStatus: '',
        minGrowthRate: '',
        maxGrowthRate: '',
      },
      reviewForm: {
        userName: '',
        bookName: '',
        reviewType: '1',
        readerName: '',
        startDate: '',
        endDate: '',
        currentReading: '',
        currentUsage: '',
        supplementaryWater: '',
        comment: '',
        meterStatus: '',
        oldMeterReading: '',
      },
      reviewRules: {
        userName: [{ required: true, message: '请选择用户', trigger: 'change' }],
        bookName: [{ required: true, message: '请选择所属表册', trigger: 'change' }],
        reviewType: [{ required: true, message: '请选择复核方式', trigger: 'change' }],
        readerName: [
          {
            validator: (rule, value, cb) => {
              if (this.reviewForm.reviewType === '2' && !value) {
                return cb(new Error('请选择抄表员'))
              }
              cb()
            },
            trigger: 'change',
          },
        ],
        startDate: [
          {
            validator: (rule, value, cb) => {
              if (this.reviewForm.reviewType === '2' && !value) {
                return cb(new Error('请选择抄表开始日期'))
              }
              if (this.reviewForm.reviewType === '2' && value) {
                const selectedDate = new Date(value)
                const today = new Date().setHours(0, 0, 0, 0)
                if (selectedDate < today) {
                  return cb(new Error('抄表开始日期不能早于今天'))
                }
              }
              cb()
            },
            trigger: 'change',
          },
        ],
        endDate: [
          {
            validator: (rule, value, cb) => {
              if (this.reviewForm.reviewType === '2' && !value) {
                return cb(new Error('请选择抄表结束日期'))
              }
              if (this.reviewForm.reviewType === '2' && value) {
                const selectedDate = new Date(value)
                const today = new Date().setHours(0, 0, 0, 0)
                if (selectedDate < today) {
                  return cb(new Error('抄表结束日期不能早于今天'))
                }
              }
              cb()
            },
            trigger: 'change',
          },
        ],
        currentReading: [
          {
            validator: (rule, value, cb) => {
              if (this.reviewForm.reviewType === '1' && !value) {
                return cb(new Error('请输入本期行至'))
              }
              if (this.reviewForm.reviewType === '1' && value) {
                const num = parseFloat(value)
                if (isNaN(num) || num <= 0) {
                  return cb(new Error('本期行至必须是大于0的数字'))
                }
              }
              cb()
            },
            trigger: 'change',
          },
        ],
        currentUsage: [
          {
            validator: (rule, value, cb) => {
              if (this.reviewForm.reviewType === '1' && value !== '' && value !== null && value !== undefined) {
                const num = parseFloat(value)
                if (isNaN(num) || num < 0) {
                  return cb(new Error('本期用水量必须是非负数'))
                }
              }
              cb()
            },
            trigger: 'change',
          },
        ],
        supplementaryWater: [
          {
            validator: (rule, value, cb) => {
              if (this.reviewForm.reviewType === '1' && value !== '' && value !== null && value !== undefined) {
                const num = parseFloat(value)
                if (isNaN(num) || num < 0) {
                  return cb(new Error('补充水量必须是非负数'))
                }
              }
              cb()
            },
            trigger: 'change',
          },
        ],
      },

      columns,
      meterReaderList: [], // 抄表员列表
      bookGroupList: [], // 表册分组列表
      meterBooksList: [], // 表册列表
      reviewStats: {
        total: 0,
        approved: 0,
        pending: 0,
      },
      imagePreviewVisible: false,
      previewImageUrl: '',
      // 放大镜相关数据
      showMagnifier: false,
      magnifierLensStyle: {},
      magnifierResultStyle: {},

      pushTime: null,
      pushCycle: null,
      autoPushEnabled: false,
      autoPushLoading: false,
      loadingCurrentSettings: false,
      autoPushForm: {},
      pushScope: 1,
      pushLoading: false,
      exportLoading: false,
      totalCount: 0,
    }
  },

  computed: {
    // 计算属性用于调试和确保响应式更新
    isReaderReview () {
      return this.reviewForm.reviewType === '2'
    },
    isAdminReview () {
      return this.reviewForm.reviewType === '1'
    },
  },

  created () {
    this.getMeterReaderData()
    this.getBookGroupData()
    this.queryList()
  },

  methods: {
    // 搜索查询（重置到第一页）
    searchList () {
      this.pagination.current = 1 // 搜索时重置到第一页
      this.queryList()
    },

    // 重写queryList方法，添加智能分页跳转逻辑
    queryList () {
      const params = {
        orderColumn: this.orderColumn,
        orderType: this.orderType,
        ...this.query,
      }
      if (this.needPage) {
        params.page = this.pagination.current
        params.limit = this.pagination.pageSize
      }
      this.dataListLoading = true
      this.$http
        .get(this.queryUrl, {
          params,
        })
        .then(({ data }) => {
          this.dataListLoading = false
          if (this.needPage) {
            this.list = data.list || []
            this.selectedRows = []
            this.pagination.total = data.total ? parseInt(data.total) : 0
            if (data.total > 0) {
              this.isadd = false
              // 如果当前页没有数据且不是第一页，自动跳转到第一页
              if (this.list.length === 0 && this.pagination.current > 1) {
                this.pagination.current = 1
                this.queryList()
              }
            } else {
              this.isadd = true
            }
          } else {
            this.list = data
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },

    handleCancelh () {
      this.visibles = false
    },
    handlePushOk () {
      // 判断是数据推送还是自动推送设置
      if (this.visiblepush) {
        // 数据推送逻辑
        if (this.pushScope === 2) {
          // 勾选推送
          this.executeSelectedPush()
        } else {
          // 全部推送
          this.executeAllPush()
        }
      } else if (this.visibleatuo) {
        // 自动推送设置逻辑
        this.saveAutoPushSettings()
      }
    },

    // 执行勾选推送
    async executeSelectedPush () {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要推送的记录')
        return
      }

      try {
        this.pushLoading = true

        const params = {
          pushMode: 1, // 1: 勾选推送
          fromHistory: false,
          batchSize: this.selectedRows.length,
          auditIds: this.selectedRows,
        }

        console.log('勾选推送参数:', params)

        const response = await this.$http.post('/meter-manager/revenue/batchPush', params)

        if (response.code == 0) {
          this.pushSuccessMessage = response.message+'：'+response.data.message
          this.pushSuccessVisible = true
          this.visiblepush = false
          // 清空选择并刷新列表
          this.selectedRows = []
          this.queryList()
        } else {
          const errorMsg = response.message || '推送失败'
          this.$message.error(errorMsg)
        }
      } catch (error) {
        console.error('推送失败:', error)
        let errorMsg = '推送失败，请稍后重试'
        if (error.response) {
          if (error.response.status === 400) {
            errorMsg = '请求参数错误，请检查推送参数'
          } else if (error.response.status === 401) {
            errorMsg = '权限不足，请检查登录状态'
          } else if (error.response.status === 500) {
            errorMsg = '服务器内部错误，请联系管理员'
          } else if (error.response.data?.message) {
            errorMsg = error.response.data.message
          }
        } else if (error.message) {
          errorMsg = error.message
        }
        this.$message.error(errorMsg)
      } finally {
        this.pushLoading = false
      }
    },

    // 执行全部推送
    async executeAllPush () {
      try {
        // 使用当前分页信息获取总记录数
        const totalCount = this.pagination.total || 0

        if (totalCount === 0) {
          this.$message.warning('当前筛选条件下没有可推送的数据')
          return
        }

        if (totalCount > 3000) {
          this.$message.warning(`当前筛选条件下有 ${totalCount} 条记录，超过最大推送限制 3000 条，请缩小筛选范围`)
          return
        }

        // 如果数据量较大，显示确认对话框
        if (totalCount > 100) {
          const confirmed = await new Promise((resolve) => {
            this.$confirm({
              title: '确认推送',
              content: `即将推送 ${totalCount} 条记录到营收系统，此操作不可撤销，是否继续？`,
              okText: '确认推送',
              cancelText: '取消',
              okType: 'danger',
              onOk: () => resolve(true),
              onCancel: () => resolve(false),
            })
          })

          if (!confirmed) {
            return
          }
        }

        // 确认推送后才设置loading状态
        this.pushLoading = true

        const params = {
          pushMode: 2, // 2: 全部推送
          batchSize: totalCount,
          ...this.query,
          fromHistory: false,
          auditIds: [], // 全部推送时不需要指定ID
        }

        console.log('全部推送参数:', params)

        const response = await this.$http.post('/meter-manager/revenue/batchPush', params)

        if (response.code == 0) {
          this.pushSuccessMessage = response.message+'：'+response.data.message
          this.pushSuccessVisible = true
          this.visiblepush = false
          // 刷新列表
          this.queryList()
        } else {
          const errorMsg = response.message || '推送失败'
          this.$message.error(errorMsg)
        }
      } catch (error) {
        console.error('推送失败:', error)
        let errorMsg = '推送失败，请稍后重试'
        if (error.response) {
          if (error.response.status === 400) {
            errorMsg = '请求参数错误，请检查推送参数'
          } else if (error.response.status === 401) {
            errorMsg = '权限不足，请检查登录状态'
          } else if (error.response.status === 500) {
            errorMsg = '服务器内部错误，请联系管理员'
          } else if (error.response.data?.message) {
            errorMsg = error.response.data.message
          }
        } else if (error.message) {
          errorMsg = error.message
        }
        this.$message.error(errorMsg)
      } finally {
        this.pushLoading = false
      }
    },

    handlePushCancel () {
      this.visiblepush = false
      this.visibleatuo = false
      // 重置自动推送设置表单
      this.autoPushLoading = false
    },
    closePushSuccessModal () {
      this.pushSuccessVisible = false
      this.pushSuccessMessage = ''
    },

    handleReview (row) {
      if (!row) {
        this.$message.error('无效的审核数据')
        return
      }

      console.log('handleReview接收到的数据:', row)

      // 使用 Object.assign 或者逐个赋值来保持响应式
      Object.assign(this.reviewForm, {
        ...row,
        reviewType: row.reviewType || '1',
      })

      console.log('handleReview设置后的reviewForm:', this.reviewForm)

      // 确保在下一个tick中清除验证
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate()
        }
      })

      this.visibles = true
    },
    handleSubmit () {
      console.log(this.reviewForm)

      if (!this.reviewForm) {
        this.$message.error('当前没有待审核的数据')
        return
      }

      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return
        const form = this.reviewForm

        // 检查必要的字段是否存在
        if (!form.id && !form.taskId) {
          this.$message.error('无法获取任务ID，请检查数据完整性')
          return
        }

        // 公共参数 - 从reviewForm获取数据，而不是currentReview
        // 尝试多种可能的表册ID字段名
        const meterBookId = form.bookId

        const baseParams = {
          currentUserId: this.$store.state.user.info.id,
          meterBookId: meterBookId,
          imageUrl: form.imageUrl,
          notes: form.comment,
          originalReading: form.previousReading,
          reviewType: form.reviewType,
          id: form.id,
          userCode: form.userCode,
          userName: form.userName,
          oldMeterReading: form.oldMeterReading, // 旧表读数（换表时需要）
        }

        let params = {}
        if (form.reviewType === '1') {
          // 管理员复核
          params = {
            ...baseParams,
            reviewedReading: form.currentReading,
            currentUsage: form.currentUsage,
            supplementaryWater: form.supplementaryWater,
          }
        } else if (form.reviewType === '2') {
          // 抄表员复核
          params = {
            ...baseParams,
            readerId: this.meterReaderList.find((r) => r.readerName === form.readerName)?.id || '',
            readerName: form.readerName,
            startDate: form.startDate,
            endDate: form.endDate,
          }
        }

        try {
          await this.$http.post('/meter-manager/water_meter_audit/review', params)
          this.$message.success('复核成功')
          this.visibles = false
          // 重新请求列表接口
          this.queryList()
          // 如果当前在快速审核模式下，重新获取下一个待审核数据
          if (this.visiblereview) {
            await this.quickReview()
          }
        } catch (error) {
          this.$message.error('复核失败')
        }
      })
    },

    getStatusColor (status) {
      // 1:待审核 红色，2:已审核 绿色，3:已推送 蓝色，其他 灰色
      if (status === 1) return 'status-unread'
      if (status === 2) return 'status-readed'
      if (status === 3) return 'status-pushed'
      return 'status-other'
    },
    getMeterStatusText (status) {
      // 1:正常,2:异常,3:已取表,4:关闸,5:重转
      const statusMap = {
        1: '正常',
        2: '异常',
        3: '已取表',
        4: '关闸',
        5: '重转',
      }
      return statusMap[status] || status || '-'
    },
    getMeterStatusColor (status) {
      // 1:正常(绿色)，2:异常(红色)，3:已取表(橙色)，4:关闸(灰色)，5:重转(蓝色)
      const colorMap = {
        1: 'meter-status-normal',
        2: 'meter-status-abnormal',
        3: 'meter-status-removed',
        4: 'meter-status-closed',
        5: 'meter-status-retransfer',
      }
      return colorMap[status] || 'meter-status-other'
    },

    handleViewImage (record) {
      if (record.imageUrl) {
        this.previewImage(record.imageUrl)
      } else {
        this.$message.info('该记录暂无图片')
      }
    },

    // 预览图片
    previewImage (imageUrl) {
      this.previewImageUrl = imageUrl
      this.imagePreviewVisible = true
    },
    // 关闭图片预览
    handleImagePreviewCancel () {
      this.imagePreviewVisible = false
      this.previewImageUrl = ''
    },

    // 处理鼠标移动事件，实现局部放大效果
    handleMouseMove (event) {
      const img = this.$refs.magnifierImage
      if (!img) return

      const rect = img.getBoundingClientRect()
      const x = event.clientX - rect.left
      const y = event.clientY - rect.top

      // 确保鼠标在图片范围内
      if (x >= 0 && y >= 0 && x <= rect.width && y <= rect.height) {
        this.showMagnifier = true

        // 放大镜透镜的大小
        const lensSize = 120
        const zoomLevel = 4 // 放大倍数

        // 计算透镜位置，确保不超出图片边界
        let lensX = x - lensSize / 2
        let lensY = y - lensSize / 2

        if (lensX < 0) lensX = 0
        if (lensY < 0) lensY = 0
        if (lensX > rect.width - lensSize) lensX = rect.width - lensSize
        if (lensY > rect.height - lensSize) lensY = rect.height - lensSize

        // 透镜样式
        this.magnifierLensStyle = {
          left: lensX + 'px',
          top: lensY + 'px',
          width: lensSize + 'px',
          height: lensSize + 'px',
        }

        // 计算放大结果的背景位置
        const bgX = -(lensX * zoomLevel)
        const bgY = -(lensY * zoomLevel)

        // 放大结果显示在图片右侧
        const resultSize = lensSize * 3.5
        this.magnifierResultStyle = {
          left: rect.width + 30 + 'px',
          top: lensY + 'px',
          width: resultSize + 'px',
          height: resultSize + 'px',
          backgroundImage: `url(${img.src})`,
          backgroundSize: `${rect.width * zoomLevel}px ${rect.height * zoomLevel}px`,
          backgroundPosition: `${bgX}px ${bgY}px`,
          backgroundRepeat: 'no-repeat',
          border: '3px solid #1890ff',
          borderRadius: '12px',
          boxShadow: '0 12px 32px rgba(0, 0, 0, 0.3)',
        }
      } else {
        this.showMagnifier = false
      }
    },

    // 鼠标离开时隐藏放大镜
    handleMouseLeave () {
      this.showMagnifier = false
    },

    dataPush () {
      // 初始化推送范围相关数据
      if (this.pushScope === 1) {
        // 全部推送时，使用分页总数
        this.totalCount = this.pagination.total || 0
      } else {
        // 勾选推送时，使用选中行数
        this.totalCount = this.selectedRows.length
      }
      this.visiblepush = true
    },

    autoDatePush () {
      this.visibleatuo = true
      // 打开弹窗时自动获取当前设置
      this.getAutoPushSettings()
    },

    // 重置自动推送表单
    resetAutoPushForm () {
      this.autoPushEnabled = false
      this.pushTime = null
      this.pushCycle = null
      this.autoPushLoading = false
      this.loadingCurrentSettings = false
    },

    // 获取当前自动推送设置
    async getAutoPushSettings () {
      this.loadingCurrentSettings = true
      try {
        const response = await this.$http.get('/meter-manager/revenue/getAutoPushBytenantId')
        if (response.code === 0 && response.data) {
          const settings = response.data
          // 处理isOpen的数据类型转换，支持字符串和数字类型
          this.autoPushEnabled = settings.isOpen === 1 || settings.isOpen === '1'
          this.pushTime = settings.pushTime || null
          // 处理pushType的数据类型转换，确保与选项值匹配
          this.pushCycle =
            settings.pushType !== null && settings.pushType !== undefined ? parseInt(settings.pushType) : null

          console.log('获取到的设置数据:', settings)
          console.log(
            '转换后的autoPushEnabled:',
            this.autoPushEnabled,
            '原始isOpen:',
            settings.isOpen,
            '类型:',
            typeof settings.isOpen
          )
          console.log('转换后的pushCycle:', this.pushCycle, '类型:', typeof this.pushCycle)
        } else {
          // 如果接口返回失败，使用默认值
          this.resetAutoPushForm()
        }
      } catch (error) {
        console.error('获取自动推送设置失败:', error)
        // 如果获取失败，使用默认值
        this.resetAutoPushForm()
      } finally {
        this.loadingCurrentSettings = false
      }
    },

    // 保存自动推送设置
    async saveAutoPushSettings () {
      // 表单验证
      if (this.autoPushEnabled) {
        if (!this.pushTime) {
          this.$message.error('请选择推送时间')
          return
        }
        if (this.pushCycle === null || this.pushCycle === '') {
          this.$message.error('请选择推送周期')
          return
        }
      }

      this.autoPushLoading = true

      try {
        // 先获取当前设置进行对比
        const currentSettings = await this.getCurrentAutoPushSettings()

        // 构建要保存的参数
        const params = {
          isOpen: this.autoPushEnabled ? 1 : 0,
          pushTime: this.pushTime || '',
          pushType: this.pushCycle !== null && this.pushCycle !== undefined ? String(this.pushCycle) : '',
        }

        console.log('当前设置:', currentSettings)
        console.log('要保存的设置:', params)

        // 检查是否有变化
        const hasChanges = this.checkSettingsChanged(currentSettings, params)

        if (!hasChanges) {
          this.$message.info('设置未发生变化')
          this.visibleatuo = false
          return
        }

        const response = await this.$http.post('/meter-manager/revenue/autoPush', params)

        if (response.code === 0) {
          this.$message.success('自动推送设置保存成功')
          this.visibleatuo = false
        } else {
          const errorMsg = response.message || '保存失败'
          this.$message.error(errorMsg)
        }
      } catch (error) {
        console.error('保存自动推送设置失败:', error)
        let errorMsg = '保存失败，请稍后重试'
        if (error.response) {
          if (error.response.status === 400) {
            errorMsg = '请求参数错误，请检查设置参数'
          } else if (error.response.status === 401) {
            errorMsg = '权限不足，请检查登录状态'
          } else if (error.response.status === 500) {
            errorMsg = '服务器内部错误，请联系管理员'
          } else if (error.response.data?.message) {
            errorMsg = error.response.data.message
          }
        } else if (error.message) {
          errorMsg = error.message
        }
        this.$message.error(errorMsg)
      } finally {
        this.autoPushLoading = false
      }
    },

    // 获取当前自动推送设置（不更新UI）
    async getCurrentAutoPushSettings () {
      try {
        const response = await this.$http.get('/meter-manager/revenue/getAutoPushBytenantId')
        if (response.code === 0 && response.data) {
          return response.data
        }
        return null
      } catch (error) {
        console.error('获取当前自动推送设置失败:', error)
        return null
      }
    },

    // 检查设置是否有变化
    checkSettingsChanged (currentSettings, newSettings) {
      if (!currentSettings) {
        return true // 如果没有当前设置，认为有变化
      }

      // 处理isOpen的数据类型比较
      const currentIsOpen = currentSettings.isOpen === 1 || currentSettings.isOpen === '1' ? 1 : 0
      const newIsOpen = newSettings.isOpen

      // 处理pushType的数据类型比较
      const currentPushType =
        currentSettings.pushType !== null && currentSettings.pushType !== undefined
          ? String(currentSettings.pushType)
          : ''
      const newPushType = newSettings.pushType || ''

      return (
        currentIsOpen !== newIsOpen ||
        currentSettings.pushTime !== newSettings.pushTime ||
        currentPushType !== newPushType
      )
    },
    async quickReview () {
      try {
        const { data } = await this.$http.post('/meter-manager/water_meter_audit/pending-with-condition', this.query)

        console.log('quickReview API返回的原始数据:', data)

        // 检查返回的数据是否为数组且有内容
        if (Array.isArray(data) && data.length > 0) {
          this.currentReview = data[0]
          console.log('quickReview设置currentReview (数组第一个元素):', this.currentReview)
        } else if (data && typeof data === 'object' && Object.keys(data).length > 0) {
          // 如果返回的是单个对象
          this.currentReview = data
          console.log('quickReview设置currentReview (单个对象):', this.currentReview)
        } else {
          this.$message.info('暂无待审核的数据')
          return
        }

        try {
          const statsRes = await this.$http.post('/meter-manager/water_meter_audit/stats', this.query)
          this.reviewStats = statsRes.data || null
        } catch (e) {
          this.reviewStats = null
        }

        this.visiblereview = true
      } catch (error) {
        this.$message.error('获取待审核数据失败')
        this.currentReview = null
      }
    },
    onUserSelectChange (value, user) {
      if (user) {
        this.query.userName = user.userName
      } else {
        this.query.userName = ''
      }
      this.pagination.current = 1 // 用户选择变化时重置到第一页
      this.queryList && this.queryList()
    },
    getMeterReaderData () {
      this.$http.get('/meter-manager/meter_readers/list').then(({ data }) => {
        this.meterReaderList = data
      })
    },
    getBookGroupData () {
      this.$http.get('/meter-manager/meter_book_groups/list').then(({ data }) => {
        this.bookGroupList = data || []
      })
    },
    getMeterBooksData (groupId = null) {
      if (!groupId) {
        this.meterBooksList = []
        return
      }
      this.$http
        .get(`/meter-manager/meter_reading_plans/meter-books?groupId=${groupId}`)
        .then(({ data }) => {
          this.meterBooksList = Array.isArray(data) ? data : data.list || data.data || []
        })
        .catch(() => {
          this.meterBooksList = []
        })
    },
    onQueryGroupChange () {
      this.query.bookId = ''
      this.pagination.current = 1 // 分组变化时重置到第一页
      if (this.query.groupId) {
        this.getMeterBooksData(this.query.groupId)
      } else {
        this.meterBooksList = []
      }
    },
    async handleApprove () {
      if (!this.currentReview) {
        this.$message.error('当前没有待审核的数据')
        return
      }
      const id = this.currentReview.taskId || this.currentReview.id
      if (!id) {
        this.$message.error('无法获取任务ID')
        return
      }
      try {
        // 构建查询参数
        const params = new URLSearchParams()
        Object.keys(this.query).forEach(key => {
          if (this.query[key] !== '' && this.query[key] !== null && this.query[key] !== undefined) {
            params.append(key, this.query[key])
          }
        })
        const queryString = params.toString()
        const url = queryString ? `/meter-manager/water_meter_audit/approve/${id}?${queryString}` : `/meter-manager/water_meter_audit/approve/${id}`

        const { data } = await this.$http.post(url)
        this.$message.success('审核成功')

        // 如果当前查询状态为待审核(1)，前端直接累加审核通过数量
        if (this.query.dataStatus === 1 && this.reviewStats) {
          this.reviewStats.approved = (this.reviewStats.approved || 0) + 1
          this.reviewStats.pending = Math.max(0, (this.reviewStats.pending || 0) - 1)
        } else {
          // 其他情况重新请求统计数据
          try {
            const statsRes = await this.$http.post('/meter-manager/water_meter_audit/stats', this.query)
            this.reviewStats = statsRes.data || null
          } catch (e) {
            this.reviewStats = null
          }
        }

        // 如果接口返回了新的待审核数据，直接更新到弹窗
        if (data && Object.keys(data).length > 0) {
          this.currentReview = data
        } else {
          // 如果没有返回数据，则重新请求下一个待审核项
          await this.refreshPendingReview()
        }

        // 重新请求列表接口
        this.queryList()
      } catch (error) {
        this.$message.error('审核失败')
      }
    },
    async handleSkip () {
      if (!this.currentReview) {
        this.$message.error('当前没有待审核的数据')
        return
      }
      const id = this.currentReview.taskId || this.currentReview.id
      if (!id) {
        this.$message.error('无法获取任务ID')
        return
      }
      try {
        // 构建查询参数
        const params = new URLSearchParams()
        Object.keys(this.query).forEach(key => {
          if (this.query[key] !== '' && this.query[key] !== null && this.query[key] !== undefined) {
            params.append(key, this.query[key])
          }
        })
        const queryString = params.toString()
        const url = queryString ? `/meter-manager/water_meter_audit/skip/${id}?${queryString}` : `/meter-manager/water_meter_audit/skip/${id}`

        const { data } = await this.$http.get(url)
        this.$message.success('跳过成功')

        // 如果当前查询状态为待审核(1)，前端直接减少待审核数量
        if (this.query.dataStatus === 1 && this.reviewStats) {
          this.reviewStats.pending = Math.max(0, (this.reviewStats.pending || 0) - 1)
        } else {
          // 其他情况重新请求统计数据
          try {
            const statsRes = await this.$http.post('/meter-manager/water_meter_audit/stats', this.query)
            this.reviewStats = statsRes.data || null
          } catch (e) {
            this.reviewStats = null
          }
        }

        // 如果接口返回了新的待审核数据，直接更新到弹窗
        if (data && Object.keys(data).length > 0) {
          this.currentReview = data
        } else {
          // 如果没有返回数据，则重新请求下一个待审核项
          await this.refreshPendingReview()
        }

        // // 重新请求列表接口
        // this.queryList()
      } catch (error) {
        this.$message.error('跳过失败')
      }
    },
    async refreshPendingReview () {
      try {
        const { data } = await this.$http.post('/meter-manager/water_meter_audit/pending-with-condition', this.query)

        // 检查返回的数据是否为数组且有内容
        if (Array.isArray(data) && data.length > 0) {
          this.currentReview = data[0]
        } else if (data && typeof data === 'object' && Object.keys(data).length > 0) {
          // 如果返回的是单个对象
          this.currentReview = data
        } else {
          // 没有待审核数据
          this.currentReview = null
          this.closeQuickReviewModal()
          this.$message.info('暂无待审核的数据')
        }
      } catch (error) {
        this.currentReview = null
        this.closeQuickReviewModal()
        this.$message.error('获取待审核数据失败')
      }
    },

    // 关闭快速审核弹窗并恢复页面滚动
    closeQuickReviewModal () {
      this.visiblereview = false
      this.$nextTick(() => {
        document.body.style.overflow = ''
        document.body.style.paddingRight = ''
        document.documentElement.style.overflow = ''
      })
    },

    // 禁用今天之前的日期
    disabledDate (current) {
      return current && current < new Date().setHours(0, 0, 0, 0)
    },

    // 处理下拉框点击事件
    handleSelectClick () {
      console.log('下拉框被点击')
    },

    // 复核方式变化处理
    onReviewTypeChange (value) {
      console.log('复核方式切换:', value)

      // 直接赋值，确保响应式更新
      this.reviewForm.reviewType = value

      if (value === '1') {
        // 管理员复核 - 清空抄表员相关字段
        this.reviewForm.readerName = ''
        this.reviewForm.startDate = ''
        this.reviewForm.endDate = ''
      } else if (value === '2') {
        // 抄表员复核 - 清空管理员相关字段
        this.reviewForm.currentReading = ''
        this.reviewForm.currentUsage = ''
        this.reviewForm.supplementaryWater = ''
      }

      // 强制更新组件
      this.$forceUpdate()

      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate()
        }
      })
    },
    // 重置查询条件
    resetList () {
      this.query = {
        userName: '',
        userCode: '',
        tenantId: this.$store.state.user.info.tenantId,
        readerId: '',
        groupId: '',
        bookId: '',
        dataStatus: '',
        meterStatus: '',
        minGrowthRate: '',
        maxGrowthRate: '',
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    exportHandleIdList () {
      // 设置加载状态
      this.exportLoading = true

      const token = this.$store.getters.token
      const url = `${process.env.VUE_APP_API_BASE_URL}meter-manager/water_meter_audit/export`

      axios
        .post(url, this.selectedRows, { headers: { Authorization: token }, responseType: 'blob' })
        .then((res) => {
          const blob = new Blob([res.data], {
            type: 'application/octet-stream;charset=utf-8',
          })
          const fileName = '抄表审核导出.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
        })
        .catch((error) => {
          console.error('导出失败:', error)
          this.$message.error('导出失败')
        })
        .finally(() => {
          // 无论成功还是失败，都要关闭加载状态
          this.exportLoading = false
        })
    },
    onPushScopeChange (e) {
      this.pushScope = e.target.value
      if (this.pushScope === 2) {
        // 勾选推送时，获取当前选中的行数
        this.totalCount = this.selectedRows.length
      } else {
        // 全部推送时，使用分页总数
        this.totalCount = this.pagination.total || 0
      }
    },

    // 处理表格行选择变化
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRows = selectedRowKeys
      // 如果当前是勾选推送模式，更新总记录数
      if (this.pushScope === 2) {
        this.totalCount = this.selectedRows.length
      }
    },

    // 翻页处理
    pageChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      // 翻页时清空选择的行
      this.selectedRows = []
      this.pageQueryList()
    },

    // 表册搜索过滤函数
    filterMeterBookOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },

  // 监听快速审核弹窗状态变化
  watch: {
    visiblereview (newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.$nextTick(() => {
          document.body.style.overflow = ''
          document.body.style.paddingRight = ''
          document.documentElement.style.overflow = ''
        })
      }
    },
    // 监听复核方式变化
    'reviewForm.reviewType': {
      handler (newVal, oldVal) {
        console.log('复核方式变化监听:', oldVal, '->', newVal)
        if (newVal !== oldVal && this.$refs.ruleForm) {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate()
          })
        }
      },
      immediate: false,
    },
  },

  // 组件销毁时确保恢复页面滚动
  beforeDestroy () {
    document.body.style.overflow = ''
    document.body.style.paddingRight = ''
    document.documentElement.style.overflow = ''
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}

/deep/ .ant-modal-body {
  padding: 24px;
}

.promptone {
  width: 500px;
  height: 50px;
  background-color: #f9e0c7;
  border-radius: 10px;
  margin: 0 25px 10px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 15px;
}

.prompttwo {
  width: 580px;
  height: 50px;
  background-color: #d4e3fc;
  border-radius: 10px;
  margin: 0 25px 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 15px;
}

.status-tag {
  width: 80px;
  text-align: center;
  font-weight: 500;
  border-radius: 4px;
  color: white !important;
}

.push-btn {
  margin-left: 12px;
  background-color: #0ed216;
  color: white;
}

.push-btn:hover {
  border-color: #0ed216;
}

/deep/ .ant-form-item-children {
  position: relative;
  display: flex;
}

.status-unread {
  color: #f5222d !important;
}

.status-readed {
  color: #52c41a !important;
}

.status-pushed {
  color: #1890ff !important;
}

.status-other {
  color: #aaa;
}

.meter-status-normal {
  color: #52c41a;
}

.meter-status-abnormal {
  color: #f5222d;
}

.meter-status-removed {
  color: #fa8c16;
}

.meter-status-closed {
  color: #8c8c8c;
}

.meter-status-retransfer {
  color: #1890ff;
}

.meter-status-other {
  color: #aaa;
}

.water-value {
  color: #1890ff;
  font-weight: bold;
}

.datepush {
  top: 20px;
  display: flex;
  flex-direction: column;
}

.select-area {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 30px 0 30px 0;
}

.autobtn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.tip {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #a2a2ab;
}

.push-tip {
  margin: 16px 0;
  padding: 0 25px;
}

.no-selection {
  text-align: center;
  padding: 20px 0;
}

.push-warning {
  margin-top: 16px;
}

.push-status-tip {
  margin-top: 16px;
}

.push-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  margin: 20px 0;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #d9d9d9;
}

.progress-text {
  margin-top: 20px;
  text-align: center;
}

.progress-title {
  font-size: 16px;
  font-weight: 500;
  color: #1890ff;
  margin-bottom: 8px;
}

.progress-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.review-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e8e8e8;
}

.recheck-button {
  background-color: #ee100b;
  color: white;
  border: none;
  padding: 5px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.recheck-button:hover {
  background-color: #ff7875;
}

.action-buttons {
  display: flex;
  gap: 12px;
}

.skip-button {
  background-color: white;
  color: rgba(0, 0, 0, 0.85);
  border: 1px solid #d9d9d9;
  padding: 5px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.skip-button:hover {
  background-color: #f8f8f8;
  border-color: #1890ff;
  color: #1890ff;
}

.approve-button {
  background-color: #1890ff;
  color: white;
  border: none;
  padding: 5px 20px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.approve-button:hover {
  background-color: #40a9ff;
}

/* 卡片样式 */
.user-info-card {
  padding: 16px;
  height: 100%;
  background-color: #fff;
}

.section-title {
  font-weight: 700;
  margin-left: 16px;
}

/* 用户信息网格布局 */
.info-grid {
  display: grid;
  grid-template-columns: 70px 1fr;
  gap: 12px 16px;
  padding-left: 20px;
}

.info-label {
  width: 100px;
  color: #9898a5;
}

.info-value {
  color: rgba(0, 0, 0, 0.85);
  word-break: break-all;
}

/* 用水数据网格 */
.water-data-grid {
  display: grid;
  grid-template-columns: 70px 1fr;
  gap: 12px 16px;
  padding-left: 20px;
  background-color: #e5ecff;
  border-radius: 10px;
  margin: 10px 0 10px 0;
}

.data-label {
  width: 100px;
  color: rgba(0, 0, 0, 0.65);
}

.data-value {
  color: rgba(6, 139, 248, 0.85);
}

/* 水表状态网格 */
.meter-status-grid {
  display: grid;
  grid-template-columns: 70px 1fr;
  gap: 12px 16px;
  padding-left: 20px;
}

/* 水表图片样式 */
.meter-image-card {
  padding: 16px;
  height: 100%;
  background-color: #fff;
}

.meter-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  border: 1px dashed #d9d9d9;
  border-radius: 8px;
  background-color: #fafafa;
}

/* 放大镜容器 */
.image-magnifier-container {
  position: relative;
  display: inline-block;
  cursor: crosshair;
}

.water-meter-image {
  max-width: 100%;
  max-height: 280px;
  object-fit: contain;
  border-radius: 4px;
  display: block;
}

/* 放大镜透镜 */
.magnifier-lens {
  position: absolute;
  border: 3px solid #1890ff;
  background-color: rgba(24, 144, 255, 0.15);
  border-radius: 50%;
  cursor: none;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.8), 0 0 10px rgba(24, 144, 255, 0.5);
}

/* 放大结果显示区域 */
.magnifier-result {
  position: absolute;
  border: 2px solid #1890ff;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  pointer-events: none;
  z-index: 20;
}

.image-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 280px;
}

/* 图片预览样式 */
.image-preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
  padding: 20px;
}

.preview-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}
</style>

<!-- 复核弹窗高层级样式，确保显示在最上面 -->
<style>
.review-modal-zindex .ant-modal {
  z-index: 2002 !important;
}

.review-modal-zindex .ant-modal-mask {
  z-index: 2001 !important;
}

/* 确保所有下拉框在模态框中正常显示 */
.ant-select-dropdown,
.ant-calendar-picker-container,
.ant-time-picker-panel {
  z-index: 2050 !important;
}

/* 针对复核弹窗内的所有下拉组件 */
.review-modal-zindex .ant-select-dropdown,
.review-modal-zindex .ant-calendar-picker-container,
.review-modal-zindex .ant-time-picker-panel {
  z-index: 2050 !important;
}

/* 确保下拉框选项可见 */
.ant-select-dropdown-menu {
  z-index: 2051 !important;
}

/* 修复可能的遮挡问题 */
.ant-modal-wrap {
  overflow: visible !important;
}

.review-modal-zindex .ant-modal-wrap {
  overflow: visible !important;
}

/* 确保消息提示显示在弹窗上方 */
.ant-message {
  z-index: 3000 !important;
}
</style>
